import { useMutation } from "@tanstack/react-query";
import type { ColumnFiltersState } from "@tanstack/react-table";
import { apiClient } from "../../../../zodios/client";
import { clientToServerFiltering } from "../../../../components/table/utils";
import { useDates } from "../../../../dates/DatesContext";
import { useAppSelector } from "../../../../redux/hooks";

export const useV4TargetReportExport = (targetType: string = "keyword", filters: ColumnFiltersState) => {
  const marketPlace = useAppSelector((state) => state.marketPlace.marketPlace);
  const { start, end, preStart, preEnd } = useDates();
  return useMutation({
    mutationFn: async () =>
      await apiClient.getV4TargetReportExport({
        queries: {
          start_date: start.format("YYYY-MM-DD"),
          end_date: end.format("YYYY-MM-DD"),
          start_date_previous: preStart.format("YYYY-MM-DD"),
          end_date_previous: preEnd.format("YYYY-MM-DD"),
          marketplace: marketPlace,
          report_type: targetType === "keyword" ? "advertised_keyword_report" : "advertised_target_report",
          table: targetType,
          filters: clientToServerFiltering(filters),
        },
        responseType: "blob",
      }),
  });
};
